exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#tab-chapters,#tab-questions,#tab-subtopics,#tab-summary,#tab-transcription{padding:0!important}", ""]);

// exports
